import setClients from './setClients';
import setClient from './setClient';
import setAvailableClients from './setAvailableClients';
import resetCurrentClient from './resetCurrentClient';
import resetClientStore from './resetClientStore';
import setDefaultClient from './setDefaultClient';
import setClientDetails from '../../clientDetails/actions/setClientDetails';
import setClientOptionsFilter from './setClientOptionsFilter';
import setCurrentClientOption from './setCurrentClientOption';
import setExcludedClientOption from './setExcludedClientOption';
import setAllClientOptionByTeam from './setAllClientOptionByTeam';
import setClientsListPagination from './setClientsListPagination';
import setAvailableClientsByPolygon from './setAvailableClientsByPolygon';
import setClientOptionsByTeam from './setClientOptionsByTeam';
import resetClientOptions from './resetClientOptions';

export default {
  setClients,
  setClient,
  setAvailableClients,
  setAvailableClientsByPolygon,
  resetCurrentClient,
  setClientDetails,
  setDefaultClient,
  resetClientStore,
  resetClientOptions,
  setClientOptionsByTeam,
  setClientOptionsFilter,
  setCurrentClientOption,
  setExcludedClientOption,
  setAllClientOptionByTeam,
  setClientsListPagination,
};
